gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);

window.addEventListener('DOMContentLoaded', ()=>{
  const hasHash = document.location.hash;
  const showIntro = (hasHash && hasHash === '#debug') ? false : true;
  const homeKvPopup = document.querySelector('.home-kv-popup');
  const notificationPopup = document.querySelector('.notification-popup');
  const hasAnchorTab = document.body.classList.contains('has-anchor-tab') && hasHash;
  const loadingDiv = document.querySelector('#loading');

  // 해시가 있으면 body에 data-has-hash 속성 추가
  if (hasHash) {
    document.body.setAttribute('data-has-hash', '');
  }

  // has-anchor-tab 클래스가 있고 해시가 있으면 loading div만 즉시 제거 (loading 클래스는 유지)
  if (hasAnchorTab && loadingDiv) {
    loadingDiv.remove();
  }

  // iframe 으로 진입 체크하여 iframe-mode 클래스 추가
  if (window.self !== window.top) {
    document.body.classList.add('iframe-mode');
  }

  window.lenis = new Lenis();
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  if (document.body.classList.contains('loading')) {
    if (showIntro) {
      gsap.delayedCall(0.5, () => {
        document.body.classList.remove('loading');
        window.dispatchEvent(new Event('SITE_START'));

        if (!hasAnchorTab) {
          if (window.lenis) {
            window.lenis.scrollTo(0, {immediate: true, force: true});
          } else {
            window.scroll(0, 0);
          }
        }
        gsap.timeline({
          onComplete: () => {
            ScrollTrigger.refresh();
            gsap.set('#header', {clearProps: 'transform'});
            gsap.set('.affiliate-banner', {clearProps: 'transform'});
          }
        })            
            .set('#header', {visibility: 'visible'})
            .fromTo('#header', {yPercent: -200}, {yPercent: 0, duration: 1.6, ease: Quint.easeOut}, 0.2)
            .fromTo('.affiliate-banner', {yPercent: -300}, {yPercent: 0, duration: 1.6, ease: Quint.easeOut}, 0.4);

        if (!homeKvPopup || !notificationPopup) return;

        gsap.delayedCall(1.2, () => {
          notificationPopup.classList.add('--active');
          homeKvPopup.classList.add('--active');
          gsap.delayedCall(5, () => {
            notificationPopup.classList.add('--hide');
            homeKvPopup.classList.remove('--active');
            homeKvPopup.classList.add('--inited');
          });
        });
      });
    } else {
      document.body.classList.remove('loading');
      if (loadingDiv) loadingDiv.remove();
      window.dispatchEvent(new Event('SITE_START'));

      if (!homeKvPopup) return;

      homeKvPopup.classList.add('--inited');
    }
  }
});

